export enum BannerGamesDisplayType {
    MultiRow = 'MultiRow',
    SingleRow = 'SingleRow',
}
